import styled from '@emotion/styled';
import { useTranslation } from '@hotjar/translations';
import { Text, tokens } from '@hotjar/hotsauce';
import type { HeatmapsData } from '@hotjar/webapp/domains/activation/featured-insights/types';
import { formatTime } from '@hotjar/insights-common/lib/format-time';
import { abbrNumber } from '@hotjar/insights-common/lib/number';
import { DetailsDefinition, DetailsLine, DetailsTitle } from '../../shared/styles';

const HeatmapsSubtitle = styled(Text)`
  display: block;
  margin-top: -6px;
  margin-bottom: ${tokens.spacer.x3};
  color: ${tokens.color.text_light};
  text-transform: uppercase;
`;

const formatClicksCount = (count: number) => (count ? abbrNumber(count) : '-');

export const HeatmapSidebar = ({ data }: { data: HeatmapsData }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <HeatmapsSubtitle textType="caption">
        {t('activation:dashboard.heatmaps-card.sub-title')}
      </HeatmapsSubtitle>
      {data.clicks ? (
        <DetailsLine>
          <DetailsTitle>
            {t(
              'activation:space-overview.for-you.featured-insights.slider.slide.heatmap.total-clicks',
            )}
            :
          </DetailsTitle>
          <DetailsDefinition>{formatClicksCount(data.clicks)}</DetailsDefinition>
        </DetailsLine>
      ) : null}
      <DetailsLine>
        <DetailsTitle>
          {t(
            'activation:space-overview.for-you.featured-insights.slider.slide.heatmap.rage-clicks',
          )}
          :
        </DetailsTitle>
        <DetailsDefinition>{formatClicksCount(data.rageClicks)}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.heatmap.u-turns')}:
        </DetailsTitle>
        <DetailsDefinition>{formatClicksCount(data.uTurns)}</DetailsDefinition>
      </DetailsLine>
      <DetailsLine>
        <DetailsTitle>
          {t('activation:space-overview.for-you.featured-insights.slider.slide.heatmap.avg-time')}:
        </DetailsTitle>
        <DetailsDefinition>{formatTime(data.averageTime)}</DetailsDefinition>
      </DetailsLine>
    </>
  );
};
